import type { SizeT } from "@patient-watch/types";
import type { ImageCountGroupT } from "../imageCountGroups";

interface Props {
    group: ImageCountGroupT;
    size?: SizeT;
}

/** The pictures of an image-and-count page, each with its label and the count given for it. */
export function ImageCountsEntryValue({ group, size }: Props) {
    const counts = group.rows.map(({ entryValue }) => entryValue.number_value);
    const sum = counts.reduce<number>((acc, count) => acc + (count ?? 0), 0);
    const countClass = size === "sm" ? "text-xl" : "text-2xl";

    return (
        <div className="space-y-2 w-full">
            <ul className="gap-3 grid grid-cols-2 md:grid-cols-3">
                {group.rows.map(({ entryValue, image }) => (
                    <li
                        key={entryValue.entry_value_id}
                        className="flex flex-col gap-2 bg-white dark:bg-slate-900/60 p-2 border border-slate-200 dark:border-slate-700 rounded-md"
                    >
                        <img
                            src={image.src}
                            alt={image.alt}
                            loading="lazy"
                            className="rounded bg-slate-50 dark:bg-slate-800 w-full aspect-square object-contain"
                        />
                        <p className="text-slate-600 dark:text-slate-300 text-sm leading-snug">
                            {entryValue.input_label}
                        </p>
                        <p
                            className={`${countClass} font-semibold text-slate-900 dark:text-slate-100 tabular-nums leading-none`}
                        >
                            {entryValue.number_value ?? "None"}
                        </p>
                    </li>
                ))}
            </ul>
            <p className="text-slate-500 dark:text-slate-400 text-xs tabular-nums">
                Total {sum}
                {group.total != null ? ` of ${group.total}` : ""}
            </p>
        </div>
    );
}
